import axiosInstance from "./axiosConfig";
import { handleAPIError } from "./utils/errors";
import {
  CreateDefaultTemplateRequest,
  DefaultTemplate,
  DefaultTemplateStatus,
  DefaultTemplateVersion,
  UpdateDefaultTemplateRequest
} from "./types/default-template";
import { VISAVALUE } from "../types/visa.type";
import { DraftType } from "./types/draft";

const BASE_URL = "/default-templates";

export const DefaultTemplatesAPI = {
  async create(data: CreateDefaultTemplateRequest): Promise<DefaultTemplate> {
    try {
      const response = await axiosInstance.post(BASE_URL, data);
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async getAll(params?: {
    status?: DefaultTemplateStatus;
    visa_type?: VISAVALUE;
    draft_type?: DraftType;
    visa_subtype?: string;
  }): Promise<DefaultTemplate[]> {
    try {
      const response = await axiosInstance.get(BASE_URL, { params });
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async getById(templateId: string): Promise<DefaultTemplate> {
    try {
      const response = await axiosInstance.get(`${BASE_URL}/${templateId}`);
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async update(
    templateId: string,
    data: UpdateDefaultTemplateRequest
  ): Promise<DefaultTemplate> {
    try {
      const response = await axiosInstance.put(
        `${BASE_URL}/${templateId}`,
        data
      );
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async updateStatus(
    templateId: string,
    status: DefaultTemplateStatus
  ): Promise<DefaultTemplate> {
    try {
      const response = await axiosInstance.put(
        `${BASE_URL}/${templateId}/status`,
        { status }
      );
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async delete(templateId: string): Promise<void> {
    try {
      await axiosInstance.delete(`${BASE_URL}/${templateId}`);
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async listVersions(
    templateId: string,
    params?: { limit?: number; offset?: number }
  ): Promise<DefaultTemplateVersion[]> {
    try {
      const response = await axiosInstance.get<DefaultTemplateVersion[]>(
        `${BASE_URL}/${templateId}/versions`,
        { params }
      );
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  },

  async restoreVersion(
    templateId: string,
    versionId: string
  ): Promise<DefaultTemplate> {
    try {
      const response = await axiosInstance.post<DefaultTemplate>(
        `${BASE_URL}/${templateId}/versions/${versionId}/restore`
      );
      return response.data;
    } catch (error) {
      const apiError = handleAPIError(error);
      throw apiError;
    }
  }
};
